import React from 'react';
import './StackPhaseNav.css';

const StackPhaseNav = ({ phases, activePhase, onPhaseEnter, onPhaseLeave }) => {
  const active = phases.find((phase) => phase.id === activePhase);

  return (
    <div className="stack-phase-nav">
      <div className="stack-phase-row">
        {phases.map((phase) => (
          <button
            key={phase.id}
            type="button"
            className={`stack-phase-btn overline${phase.id === activePhase ? ' stack-phase-btn--active' : ''}`}
            onMouseEnter={() => onPhaseEnter(phase.id)}
            onMouseLeave={onPhaseLeave}
            onFocus={() => onPhaseEnter(phase.id)}
            onBlur={onPhaseLeave}
          >
            {phase.label}
          </button>
        ))}
      </div>
      <p className={`stack-phase-desc${active ? ' stack-phase-desc--visible' : ''}`}>
        {active ? active.description : ' '}
      </p>
    </div>
  );
};

export default StackPhaseNav;
